<fidelity-overlay-page-wrapper
    *transloco="let t; prefix 'fidelity-app'"
    [headerCaption]="t('account.consent.heading')"
>
    <div pageContent class="p-4 flex flex-col h-full" *transloco="let gt" [formGroup]="consentForm">
        @if (fetchingData()) {
            <generic-page-loading-state class="my-auto text-tb-primary"></generic-page-loading-state>
        } @else {
            <h2>{{ t('account.consent.title') }}</h2>
            <mat-list class="w-full">
                <mat-list-item class="flex justify-between ps-0">
                    <span matListItemTitle class="text-lg">{{ t('register.marketing') }}</span>
                    <mat-slide-toggle matListItemMeta class="my-auto" formControlName="consentMarketing"
                                      labelPosition="before"></mat-slide-toggle>
                </mat-list-item>
                <mat-list-item class="flex justify-between ps-0">
                    <span matListItemTitle class="text-lg">{{ t('register.profiling') }}</span>
                    <mat-slide-toggle matListItemMeta class="my-auto" formControlName="consentProfiling"
                                      labelPosition="before"></mat-slide-toggle>
                </mat-list-item>
            </mat-list>

            <mat-divider></mat-divider>

            @if (legalDocuments()?.length > 0) {
                <div>
                    <mat-divider></mat-divider>
                    <h3 class="text-tb-primary text-start mt-4">{{ t('more.information.legal-docs') }}</h3>
                    <ul class="list-disc ml-4 py-2 text-start">
                        @for (doc of legalDocuments(); track doc.url) {
                            <li>
                                <a target="_blank" [href]="doc.url">{{ doc.text }}</a>
                            </li>
                        }
                    </ul>
                </div>
            }

            <button
                class="fuse-mat-button-large mt-6 w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                mat-flat-button
                [disabled]="disableSave()"
                (click)="saveChanges()"
            >
                @if (!disableCrudActions()) {
                    <span>
                        {{ gt('generic.save') }}
                    </span>
                } @else {
                    <mat-progress-spinner
                        [diameter]="24"
                        [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                }
            </button>
        }
    </div>
</fidelity-overlay-page-wrapper>
